import React, { useState, useEffect } from 'react';
import api from '../services/api';

const s = {
  page: { maxWidth: 1100, margin: '0 auto', padding: '3rem 2rem' },
  title: { fontFamily: 'Fraunces, serif', fontSize: '2rem', fontWeight: 600, color: '#1c1814', marginBottom: '0.5rem' },
  sub: { color: '#7a6f65', marginBottom: '2rem' },
  card: { background: '#fff', border: '1px solid #e2dbd0', borderRadius: 16, padding: '1.5rem', marginBottom: '1.25rem' },
  campTitle: { fontWeight: 600, color: '#1c1814', marginBottom: '0.25rem' },
  campMeta: { fontSize: '0.8rem', color: '#7a6f65', marginBottom: '1rem' },
  row: { display: 'flex', gap: '0.75rem', flexWrap: 'wrap' },
  btnApprove: { background: '#1e6f3e', color: '#fff', border: 'none', borderRadius: 8, padding: '0.5rem 1.2rem', fontWeight: 600, cursor: 'pointer', fontSize: '0.82rem' },
  btnReject: { background: '#c0392b', color: '#fff', border: 'none', borderRadius: 8, padding: '0.5rem 1.2rem', fontWeight: 600, cursor: 'pointer', fontSize: '0.82rem' },
  stats: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem', marginBottom: '2.5rem' },
  statBox: { background: '#fff', border: '1px solid #e2dbd0', borderRadius: 12, padding: '1.25rem', textAlign: 'center' },
  statN: { fontFamily: 'Fraunces, serif', fontSize: '1.8rem', fontWeight: 600, color: '#c0392b' },
  statL: { fontSize: '0.78rem', color: '#7a6f65', marginTop: '0.25rem' },
  empty: { textAlign: 'center', color: '#7a6f65', padding: '3rem', background: '#faf7f2', borderRadius: 12 },
};

export default function AdminPanel() {
  const [stats, setStats] = useState(null);
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');

  const load = async () => {
    try {
      const [s, p] = await Promise.all([
        api.get('/admin/stats'),
        api.get('/admin/campaigns/pending'),
      ]);
      setStats(s.data);
      setPending(p.data.content || []);
    } catch (e) {
      setMsg('Failed to load admin data.');
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try { await api.post(`/admin/campaigns/${id}/approve`); load(); setMsg('Campaign approved!'); }
    catch { setMsg('Failed to approve.'); }
  };

  const reject = async (id) => {
    const reason = prompt('Rejection reason:');
    if (!reason) return;
    try { await api.post(`/admin/campaigns/${id}/reject?reason=${encodeURIComponent(reason)}`); load(); setMsg('Campaign rejected.'); }
    catch { setMsg('Failed to reject.'); }
  };

  if (loading) return <div style={s.page}><p style={{ color: '#7a6f65' }}>Loading admin panel...</p></div>;

  return (
    <div style={s.page}>
      <h1 style={s.title}>Admin Panel</h1>
      <p style={s.sub}>Review and manage campaigns</p>
      {msg && <div style={{ background: '#edf7f2', color: '#1e6f3e', padding: '0.75rem 1rem', borderRadius: 8, marginBottom: '1.5rem', fontSize: '0.875rem' }}>{msg}</div>}

      {stats && (
        <div style={s.stats}>
          {[
            [stats.totalCampaigns, 'Total campaigns'],
            [stats.pendingCampaigns, 'Pending review'],
            [stats.approvedCampaigns, 'Approved'],
            [stats.totalDonors, 'Total donors'],
            [`₹${stats.totalAmountRaised?.toLocaleString() || 0}`, 'Total raised'],
          ].map(([n, l]) => (
            <div key={l} style={s.statBox}><div style={s.statN}>{n}</div><div style={s.statL}>{l}</div></div>
          ))}
        </div>
      )}

      <h2 style={{ fontWeight: 600, color: '#1c1814', marginBottom: '1.25rem', fontSize: '1.1rem' }}>
        Pending campaigns ({pending.length})
      </h2>

      {pending.length === 0 && <div style={s.empty}>No pending campaigns 🎉</div>}

      {pending.map(c => (
        <div key={c.id} style={s.card}>
          <div style={s.campTitle}>{c.title}</div>
          <div style={s.campMeta}>{c.formerRole} · {c.formerCompany} · by {c.creatorName} · Goal: {c.currency} {c.goalAmount?.toLocaleString()}</div>
          <p style={{ fontSize: '0.85rem', color: '#7a6f65', marginBottom: '1rem', lineHeight: 1.6 }}>{c.story?.substring(0, 200)}...</p>
          <div style={s.row}>
            <button style={s.btnApprove} onClick={() => approve(c.id)}>✓ Approve</button>
            <button style={s.btnReject} onClick={() => reject(c.id)}>✗ Reject</button>
          </div>
        </div>
      ))}
    </div>
  );
}
